import { ASSETS } from '@/constants/assets';

export default function AboutSection() {
  return (
    <section id="about" className="relative bg-cream py-24 overflow-hidden">
      <div className="px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="absolute -top-6 -left-6 text-gp-yellow/10 font-display text-[180px] font-bold leading-none select-none">
              18
            </div>
            <div className="relative">
              <img
                src={ASSETS.excelenciaHidraulica}
                alt="Unidade hidráulica industrial da Pilar com motor, bombas, manômetros e conexões em operação"
                className="w-full h-[400px] object-cover rounded-lg shadow-xl"
                style={{
                  imageRendering: '-webkit-optimize-contrast',
                  maxWidth: '100%',
                }}
                loading="eager"
                decoding="async"
              />
              <div className="absolute -bottom-6 -right-6 bg-gp-yellow p-6 rounded-lg shadow-xl">
                <p className="font-display text-4xl font-bold text-gp-graphite">18+</p>
                <p className="text-gp-graphite text-sm uppercase tracking-wider mt-1">Anos de<br/>experiência</p>
              </div>
            </div>
          </div>

          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-[2px] bg-gp-yellow"></div>
              <span className="text-gp-yellow text-sm uppercase tracking-[0.3em] font-medium">Sobre Nós</span>
            </div>

            <h2 className="font-display text-4xl md:text-5xl font-bold text-gp-graphite uppercase mb-8 leading-tight">
              Excelência em<br />
              <span className="text-gp-yellow">Hidráulica Industrial</span>
            </h2>

            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              Há mais de 18 anos, a <strong className="text-gp-graphite">Grupo Pilar</strong> é referência em serviços hidráulicos no Brasil. Nossa equipe de engenheiros e técnicos especializados atende desde pequenas manutenções até grandes projetos industriais.
            </p>

            <p className="text-gray-600 leading-relaxed mb-8">
              Com unidades de atendimento em campo e uma oficina equipada com tecnologia de ponta, oferecemos soluções completas: desde o diagnóstico emergencial até o fornecimento de componentes hidráulicos através da nossa divisão <strong className="text-df-orange">DURAFLOW</strong>.
            </p>

            <div className="grid grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-gp-graphite rounded-sm flex items-center justify-center flex-shrink-0">
                  <i className="ri-tools-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gp-graphite text-sm uppercase tracking-wider">Técnicos Certificados</h4>
                  <p className="text-gray-500 text-sm mt-1">Equipe altamente qualificada</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-gp-graphite rounded-sm flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gp-graphite text-sm uppercase tracking-wider">Cobertura Nacional</h4>
                  <p className="text-gray-500 text-sm mt-1">Atendimento em todo Brasil</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-gp-graphite rounded-sm flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gp-graphite text-sm uppercase tracking-wider">Garantia Total</h4>
                  <p className="text-gray-500 text-sm mt-1">Garantia em todos os serviços</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}